import React from 'react';
import { styled } from '@linaria/react';

/**
 * XXX transparent if no children
 */
const Hint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => (props.children ? 'var(--bb-hint-background)' : 'transparent')};
  border-radius: var(--bb-hint-border-radius);
  padding-top: var(--bb-hint-padding-top);
  padding-right: var(--bb-hint-padding-right);
  padding-bottom: var(--bb-hint-padding-bottom);
  padding-left: var(--bb-hint-padding-left);
  white-space: nowrap;
  margin-left: 12px;
  min-width: 130px;
  box-sizing: border-box;
  color: var(--bb-hint-color);
`;

export default props => <Hint {...props} />;
